<template>
  <ProductListing tax="price_range" :terms="{ price_range: slug }" />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import ProductListing from "~/components/Product/ProductListing.vue";

const slug = ref<string[]>([]);
const route = useRoute()

if (Array.isArray(route.params.slug)) {
  slug.value = route.params.slug.filter(value => value !== "");
} else if (typeof route.params.slug === 'string') {
  slug.value = route.params.slug !== "" ? [route.params.slug] : [];
} else {
  slug.value = [];
}

// definePageMeta middleware removed - API handles taxonomy validation
</script>